export default __webpack_public_path__ + "static/media/upload_new.3e1cb577.svg";